module.exports = __webpack_public_path__ + "static/media/Popup-yritys-thumbnail.43b7248a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/screenCaptures/Popup-yritys-thumbnail.png
// module id = 1432
// module chunks = 0